// Background SVG imports
import blobHaikei from "../../../assets/backgrounds/blob-haikei.svg";
import blobScatterHaikei from "../../../assets/backgrounds/blob-scatter-haikei.svg";
import blobSceneHaikei from "../../../assets/backgrounds/blob-scene-haikei.svg";
import blurryGradientHaikei from "../../../assets/backgrounds/blurry-gradient-haikei.svg";
import circleScatterHaikei from "../../../assets/backgrounds/circle-scatter-haikei.svg";
import layeredWavesHaikei from "../../../assets/backgrounds/layered-waves-haikei.svg";
import lowPolyGridHaikei from "../../../assets/backgrounds/low-poly-grid-haikei.svg";
import polygonScatterHaikei from "../../../assets/backgrounds/polygon-scatter-haikei.svg";
import polygonScatterHaikei1 from "../../../assets/backgrounds/polygon-scatter-haike.svg";
import stackedPeaksHaikei from "../../../assets/backgrounds/stacked-peaks-haikei.svg";
import stackedWavesHaikei from "../../../assets/backgrounds/stacked-waves-haikei.svg";
import symbolScatterHaikei from "../../../assets/backgrounds/symbol-scatter-haikei.svg";

// Default background import
import classicalBackground from "../../../assets/classical-background.jpg";

export const AVAILABLE_BACKGROUNDS = [
  "blob", // default background
  "classical",
  "blob-scatter",
  "blob-scene",
  "blurry-gradient",
  "circle-scatter",
  "layered-waves",
  "low-poly-grid",
  "polygon-scatter",
  "polygon-scatter-alt",
  "stacked-peaks",
  "stacked-waves",
  "symbol-scatter",
];

export const backgroundImages = {
  classical: classicalBackground,
  blob: blobHaikei,
  "blob-scatter": blobScatterHaikei,
  "blob-scene": blobSceneHaikei,
  "blurry-gradient": blurryGradientHaikei,
  "circle-scatter": circleScatterHaikei,
  "layered-waves": layeredWavesHaikei,
  "low-poly-grid": lowPolyGridHaikei,
  "polygon-scatter": polygonScatterHaikei,
  "polygon-scatter-alt": polygonScatterHaikei1,
  "stacked-peaks": stackedPeaksHaikei,
  "stacked-waves": stackedWavesHaikei,
  "symbol-scatter": symbolScatterHaikei,
};

export const backgroundNames = {
  classical: "Classical",
  blob: "Blob",
  "blob-scatter": "Blob Scatter",
  "blob-scene": "Blob Scene",
  "blurry-gradient": "Blurry Gradient",
  "circle-scatter": "Circle Scatter",
  "layered-waves": "Layered Waves",
  "low-poly-grid": "Low Poly Grid",
  "polygon-scatter": "Polygon Scatter",
  "polygon-scatter-alt": "Polygon Scatter Alt",
  "stacked-peaks": "Stacked Peaks",
  "stacked-waves": "Stacked Waves",
  "symbol-scatter": "Symbol Scatter",
};
